import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-[var(--bg)] h-full" }
const _hoisted_2 = { class: "flex-1 flex flex-col" }
const _hoisted_3 = { class: "min-h-screen" }
const _hoisted_4 = {
  key: 0,
  class: "bg-[var(--bg)] group"
}
const _hoisted_5 = { class: "container mx-auto px-12 text-center sm:px-24" }
const _hoisted_6 = { class: "flex flex-col justify-between w-full py-16 mb-8 sm:flex-row sm:items-start" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "flex space-x-12 mr-0 opacity-30 group-hover:opacity-100 transition-all duration-500 ease-in-out sm:mr-20 sm:mx-0 sm:space-x-20" }
const _hoisted_10 = { class: "text-left" }
const _hoisted_11 = { class: "space-y-2 text-xs text-[var(--text)] font-light pl-1" }
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = { class: "space-y-2 text-xs text-[var(--text)] font-light pl-1" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "flex justify-between items-center border-t border-[var(--border)] pt-8 pb-20" }
const _hoisted_16 = { class: "text-xs text-[var(--text-secondary)] font-light" }
const _hoisted_17 = ["src"]

import {
  computed,
  watch,
  defineAsyncComponent,
  ref,
} from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import router from '@/router';
import Notifications from '@/components/global/notifications.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const route = useRoute();

const { VUE_APP_DG_USERS_APP } = process.env;

const NavBar = defineAsyncComponent(() => import('./components/global/nav-bar.vue'));
const Sidebar = defineAsyncComponent(() => import('@/components/global/sidebar.vue'));

const usersLink = ref(`${VUE_APP_DG_USERS_APP}`);

const isHome = computed(() => route.name === 'home');
const hideBar = computed(() => route.name === 'home' || route.name === 'login' || route.name === 'register');
const isAuth = computed(() => store.getters['auth/isAuth']);
const isLight = computed(() => store.state.theme?.theme === 'light');
const showSidebar = computed(() => isAuth.value && route.name !== 'home');
const showSidebarState = computed<boolean>(() => store.state.sidebar);
const showSidebarMovil = computed(() => showSidebarState.value);
const currentYear = new Date().getFullYear();

function clickOutside() {
  if (showSidebar.value) store.commit('toggleSidebar');
}

const toggleTheme = () => {
  store.dispatch('theme/toggleTheme');
  const newTheme = store.state.theme.theme;

  document.documentElement.classList.toggle('light', newTheme === 'light');
};

function toggleSidebar() {
  store.commit('toggleSidebar');
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showSidebar.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black opacity-50 z-30 hidden",
          onClick: toggleSidebar,
          onKeydown: toggleSidebar
        }, null, 32))
      : _createCommentVNode("", true),
    _createVNode(_unref(NavBar)),
    _createVNode(Notifications),
    _createElementVNode("div", {
      class: _normalizeClass(["overflow-y-auto transition-[padding] duration-300", 
        !isAuth.value || isHome.value
          ? 'pl-0'
          : _unref(store).state.sidebar
            ? 'sm:pl-0'
            : 'sm:pl-0'
      ])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_view)
        ]),
        (!showSidebar.value)
          ? (_openBlock(), _createElementBlock("footer", _hoisted_4, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "w-full h-px bg-line" }, null, -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("a", {
                    href: `${usersLink.value}`,
                    target: "_blank",
                    class: "mb-10 sm:mb-0"
                  }, [
                    _createElementVNode("img", {
                      src: isLight.value
                  ? '/img/logo-digi-light.svg'
                  : '/img/logo-digi.svg',
                      alt: "Logo",
                      class: "h-6 opacity-30 group-hover:opacity-100 courser-pointer"
                    }, null, 8, _hoisted_8)
                  ], 8, _hoisted_7),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-sm text-[var(--text)] font-regular mb-4" }, "Products", -1)),
                      _createElementVNode("ul", _hoisted_11, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            to: isAuth.value ? '/app' : '/',
                            class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                          }, {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                              _createTextVNode(" Sky ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        _cache[1] || (_cache[1] = _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: "https://fireweb.digiapps.com.co/",
                            target: "_blank",
                            class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                          }, " Fireweb ")
                        ], -1)),
                        _cache[2] || (_cache[2] = _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: "https://care.digiapps.com.co/",
                            target: "_blank",
                            class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                          }, " Care ")
                        ], -1)),
                        _cache[3] || (_cache[3] = _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: "https://utils.digiapps.com.co/",
                            target: "_blank",
                            class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                          }, " Utils ")
                        ], -1))
                      ])
                    ]),
                    _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"text-left\" data-v-ff3695c0><h3 class=\"text-sm text-[var(--text)] font-regular mb-4\" data-v-ff3695c0>Contact Us</h3><ul class=\"space-y-2 text-xs text-[var(--text)] font-light pl-1\" data-v-ff3695c0><li data-v-ff3695c0><a href=\"https://mail.google.com/mail/?view=cm&amp;fs=1&amp;to=support@digiapps.com.co\" target=\"_blank\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-ff3695c0> Help Center </a></li><li data-v-ff3695c0><a href=\"https://discord.gg/n8NHa6sJbc\" target=\"_blank\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-ff3695c0> Discord </a></li></ul></div>", 1)),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-sm text-[var(--text)] font-regular mb-4" }, "Legal", -1)),
                      _createElementVNode("ul", _hoisted_13, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: `${usersLink.value}/privacy-policy`,
                            target: "_blank",
                            class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                          }, " Privacy Policy ", 8, _hoisted_14)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("p", _hoisted_16, "© " + _toDisplayString(_unref(currentYear)) + " digi systems All rights reserved.", 1),
                  _createElementVNode("button", {
                    onClick: toggleTheme,
                    class: "rounded-full"
                  }, [
                    _createElementVNode("img", {
                      src: isLight.value
                  ? '/icon/icon-light.svg'
                  : '/icon/icon-dark.svg',
                      alt: "theme toggle",
                      class: "w-5 h-5 opacity-70 hover:opacity-100 transition"
                    }, null, 8, _hoisted_17)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}
}

})